module.exports = __webpack_public_path__ + "static/media/c10.d4d96db2.jpg";